import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { useTranslation } from '@gem/modules/i18n';

import { GroupAvatar } from 'APP/components/Avatar/GroupAvatar/GroupAvatar';
import { SecureChatBadge } from 'APP/components/SecureChatBadge/SecureChatBadge';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import { Group } from 'STORE/Groups/Group';

import { ISearchResultItemProps } from '../SearchResultItem.types';
import styles from './SearchResultSecretGroup.style.m.css';

export const SearchResultSecretGroup: FC<ISearchResultItemProps<Group>> = observer(
  ({ entity: group, className, activeClassName }) => {
    const { t } = useTranslation();

    return (
      <NavLink
        className={({ isActive }): string =>
          isActive ? classNames(className, activeClassName) : className
        }
        to={`/${group.route}/${group.id}`}
      >
        <GroupAvatar group={group} />
        <div className={styles.content}>
          <div className={styles.top}>
            {group.isSecretGroup && <SecureChatBadge />}
            <div className={styles.header}>{group.avatarTitle}</div>
            {group.verified && <VerifiedBadge />}
          </div>
          <div className={styles.bottom}>
            <div className={styles.description}>{`${t('chat_details_group_members_label')}: ${
              group.usersCount
            }`}</div>
          </div>
        </div>
      </NavLink>
    );
  }
);
